import { getStaticAssets } from '@/lib/staticAssets'

interface Props {
  imgSrc: string
  altText: string
}

export default function ExampleTransaction({
  imgSrc,
  altText,
}: Readonly<Props>) {
  const staticAsset = getStaticAssets(window.location.hostname)

  return (
    <img src={`${staticAsset(imgSrc)}`} alt={altText} className="h-[141px]" />
  )
}
